export enum CourtshipTypeEnum {
  /**
   * No courtship
   */
  NONE = 'NONE',
  /**
   * Standard courtship
   */
  STANDARD = 'STANDARD'
}

export namespace CourtshipTypeEnum {
  export function next(court: CourtshipTypeEnum): CourtshipTypeEnum {
    if (court === CourtshipTypeEnum.NONE) {
      return CourtshipTypeEnum.STANDARD;
    } if (court === CourtshipTypeEnum.STANDARD) {
      return CourtshipTypeEnum.NONE;
    }
  }
}

export const CourtshipTypeLabels: Record<CourtshipTypeEnum, string> = {
  [CourtshipTypeEnum.NONE]: 'None',
  [CourtshipTypeEnum.STANDARD]: 'Standard'
};
